var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.994,
    height: 80,
    viewBox: "0 0 89.994 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14713",
    "data-name": "Group 14713",
    transform: "translate(10827 20464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12115",
    "data-name": "Path 12115",
    d: "M67.524,30.5a8.305,8.305,0,0,1,7.167,4.133l36.72,63.439a8.281,8.281,0,0,1-7.167,12.429H30.8a8.281,8.281,0,0,1-7.167-12.429l36.72-63.439A8.305,8.305,0,0,1,67.524,30.5Zm36.72,76.8a5.075,5.075,0,0,0,4.393-7.618L71.917,36.238a5.075,5.075,0,0,0-8.786,0L26.412,99.677A5.075,5.075,0,0,0,30.8,107.3Z",
    transform: "translate(-10849.527 -20494.5)",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_266",
    "data-name": "Line 266",
    d: "M.1,25.079a1.6,1.6,0,0,1-1.6-1.6V.1A1.6,1.6,0,1,1,1.706.1V23.476A1.6,1.6,0,0,1,.1,25.079Z",
    transform: "translate(-10781.691 -20440.797)",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_631",
    "data-name": "Ellipse 631",
    cx: 3.339,
    cy: 3.339,
    r: 3.339,
    transform: "translate(-10785.328 -20409.975)",
    fill: "#A3AED0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.5d9007b198c58d108a0551e11f487c09.svg";
export { ForwardRef as ReactComponent };